<script lang="ts">
  let className: string;

  // creates a `class` property, even
  // though it is a reserved word
  export { className as class };
</script>

<ul
  class="ml-8 py-6 border-l-2 border-gray-400 flex flex-col space-y-6 {className}">
  <slot />
</ul>
